import gql from "graphql-tag"

export default gql`
  query episodeUpgradeTarget($id: String!) {
    episode: episodeGet(id: $id) {
      id
      Media {
        id
      }
    }
  }
`
